import {GroupUL} from 'ApplicationEntry/models/ProductsRiders/UniversalLife/GroupUL';
import {NewYorkUL} from 'ApplicationEntry/models/ProductsRiders/UniversalLife/NewYorkUL';
import {OrdUL} from 'ApplicationEntry/models/ProductsRiders/UniversalLife/OrdinaryUL';

export type UniversalLife = OrdUL | GroupUL | NewYorkUL;

type ExhaustiveULOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdUL) => TReturn;
  Group: (group: GroupUL) => TReturn;
  NewYork: (newYork: NewYorkUL) => TReturn;
};

type PartialULOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdUL) => TReturn;
  Group?: (group: GroupUL) => TReturn;
  NewYork?: (newYork: NewYorkUL) => TReturn;
  _: (app: UniversalLife) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: ULByTypeOptions<TReturn>
): options is ExhaustiveULOptionsByType<TReturn> => !!options.Ordinary || (!!options.Group && !!options.NewYork);

type ULByTypeOptions<TReturn> = PartialULOptionsByType<TReturn> | ExhaustiveULOptionsByType<TReturn>;

export const matchULByType = <TReturn>(options: ULByTypeOptions<TReturn>) => (app: UniversalLife): TReturn => {
  switch (app.key) {
    case 'InvalidOrdUL':
    case 'ValidOrdUL':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupUL':
    case 'ValidGroupUL':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkUL':
    case 'ValidNewYorkUL':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidUL = (ul: UniversalLife) =>
  ul.key === 'ValidOrdUL' || ul.key === 'ValidGroupUL' || ul.key === 'ValidNewYorkUL';

export type riderCodeType = {code: string; units: number[]};

export const typeList = ['Employee', 'Spouse', 'Child', 'Option'];

export const smokerValues = ['Smoker', 'Non Smoker'];
